import React, {useEffect} from "react";
import {useFilePicker} from "./FilePicker";
import {Button, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import {Dialog2} from "../../../../misc/Dialog2";
import {useAsyncAction} from "nate-react-api-helpers";
import {api} from "../../../../api/API";
import {useSyncedRef} from "../../../../misc/SyncedRef";

type Item = {
    id: number;
    name: string;
}

export function ProductFileLookup(props: {
    title: string;
    onDone(value: Item | null): void;
}) {
    const filePicker = useFilePicker({
        accept: ["application/pdf", "image/*"]
    });

    const onDoneRef = useSyncedRef(props.onDone)
    const action = useAsyncAction(async (file: File) => {
        const fileObj = await api.files.upload({
            file: file,
        });

        onDoneRef.current({
            id: fileObj.id,
            name: file.name,
        });
    }, [filePicker]);

    const filePickerRef = useSyncedRef(filePicker);
    const callbackRef = useSyncedRef(action.callback)

    useEffect(() => {
        (async () => {
            const files = await filePickerRef.current();
            if (files.length === 0) {
                onDoneRef.current(null);
                return;
            }

            callbackRef.current(files[0]);
        })();
    }, [filePickerRef, callbackRef, onDoneRef]);

    return (
        <Dialog2 open onClose={e => props.onDone(null)}>
            <DialogTitle>{props.title}</DialogTitle>
            <DialogContent>
                <div style={{height: 8}} />
                {action.LoadingElement}
            </DialogContent>
            <DialogActions>
                <Button onClick={e => props.onDone(null)}>Cancel</Button>
            </DialogActions>
        </Dialog2>
    )
}